import { BackendConfigEnvDebugEnum } from 'common/data/backend/config/env-debug.enum';
import { configGetEnv } from 'common/helper/config/get-env';

export const AutocompleteCacheLocationsGetIsDelayed = (): boolean => {
  const env = configGetEnv();
  return env.debug?.includes(BackendConfigEnvDebugEnum.delaylocations);
};
